module.exports = __webpack_public_path__ + "img/video_cover.9b4a11f2.jpg";